import { render, staticRenderFns } from "./image-search-similar-results-wrapper.vue?vue&type=template&id=58ec2a08&"
import script from "./image-search-similar-results-wrapper.vue?vue&type=script&lang=js&"
export * from "./image-search-similar-results-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports